import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

var _dec, _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys(source, true)).call(_context3, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys(source)).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { autobind } from 'core-decorators';
import { styled, StyleSheet } from '@rexlabs/styling';
import Tab from './tab';
import { get } from 'lodash';
var defaultStyles = StyleSheet({
  list: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    marginBottom: '-0.3rem',
    alignItems: 'flex-start'
  },
  indicator: {
    height: '0.2rem',
    background: 'black',
    transformOrigin: '0 0'
  }
});
var TabBar = (_dec = styled(defaultStyles), _dec(_class = autobind(_class = (_temp =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TabBar, _React$Component);

  function TabBar() {
    var _getPrototypeOf2, _context;

    var _this;

    _classCallCheck(this, TabBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TabBar)).call.apply(_getPrototypeOf2, _concatInstanceProperty(_context = [this]).call(_context, args)));

    _defineProperty(_assertThisInitialized(_this), "_refs", {});

    _defineProperty(_assertThisInitialized(_this), "state", {
      indicatorStyles: {}
    });

    _defineProperty(_assertThisInitialized(_this), "throttle", null);

    return _this;
  }

  _createClass(TabBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setActiveTab(this.props.activeTab, this.props, false);
      window.addEventListener('resize', this.setActiveTabThrottled);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.setActiveTabThrottled);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.activeTab !== this.props.activeTab) {
        this.setActiveTab(nextProps.activeTab, nextProps, true);
      }
    }
  }, {
    key: "setActiveTabThrottled",
    value: function setActiveTabThrottled() {
      var _this2 = this;

      clearTimeout(this.throttle);
      this.throttle = _setTimeout(function () {
        return _this2.setActiveTab(_this2.props.activeTab);
      }, 200);
    }
  }, {
    key: "setActiveTab",
    value: function setActiveTab(activeTab) {
      var _context2;

      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var setTransition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var s = props.styles;
      this.setState({
        indicatorStyles: _objectSpread({}, s('tabBarIndicator').style, {
          transform: _concatInstanceProperty(_context2 = "translateX(".concat(get(this._refs, "".concat(activeTab, ".offsetLeft")) - get(this._refs, 'parent.offsetLeft'), "px) scaleX(")).call(_context2, get(this._refs, "".concat(activeTab, ".offsetWidth")) / get(this._refs, 'parent.offsetWidth'), ")")
        }, setTransition ? {
          transition: 'transform 150ms ease-out '
        } : {})
      });
    }
  }, {
    key: "setTabRef",
    value: function setTabRef(ref, _ref) {
      var name = _ref.name;
      this._refs[name] = ref;
    }
  }, {
    key: "handleTabClick",
    value: function handleTabClick(event, _ref2) {
      var name = _ref2.name;
      var _this$props = this.props,
          onChange = _this$props.onChange,
          items = _this$props.items,
          activeTab = _this$props.activeTab;

      if (onChange) {
        onChange({
          name: name,
          newIndex: _findIndexInstanceProperty(items).call(items, function (i) {
            return i.name === name;
          }),
          oldIndex: _findIndexInstanceProperty(items).call(items, function (i) {
            return i.name === activeTab;
          })
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          activeTab = _this$props2.activeTab,
          items = _this$props2.items,
          tabItemStyles = _this$props2.tabItemStyles,
          s = _this$props2.styles;
      var indicatorStyles = this.state.indicatorStyles;
      return React.createElement("div", s('container'), React.createElement("ul", _extends({}, s('list'), {
        ref: function ref(r) {
          return _this3._refs.parent = r;
        },
        role: "tablist"
      }), _mapInstanceProperty(items).call(items, function (_ref3, index) {
        var name = _ref3.name,
            label = _ref3.label,
            isDisabled = _ref3.isDisabled;
        return React.createElement(Tab, {
          key: name,
          index: index,
          isDisabled: isDisabled,
          styles: tabItemStyles,
          name: name,
          label: label,
          isActive: name === activeTab || !activeTab && index === 0,
          setRef: _this3.setTabRef,
          onClick: _this3.handleTabClick
        });
      })), React.createElement("div", _extends({}, s('indicator'), {
        style: indicatorStyles
      })));
    }
  }]);

  return TabBar;
}(React.Component), _temp)) || _class) || _class);
export default TabBar;